import docReady from './Functions/docReady'
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'
import tippy, { followCursor } from 'tippy.js';
import Hammer from 'hammerjs'

docReady(function () {
    //$('[data-toggle="tooltip"]').tooltip();
    document.body.classList.add('page-print');
    document.body.classList.add('page-print-jpeg-vue');
    // order important!
    if (!model.oneStep) {
        PageNavigation.init();

        const collection = document.getElementsByClassName('pic-under-navbar');
        if (collection.length) {
            collection[0].classList.add('twostep');
        }
    }
    //var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    //var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);  
    function iOSSafari(userAgent) {
        return /iP(ad|od|hone)/i.test(userAgent) &&
            /WebKit/i.test(userAgent) &&
            !(/(CriOS|FxiOS|OPiOS|mercury|GSA)/i.test(userAgent));
    }
    if (iOSSafari(window.navigator.userAgent)) {
        const collection = document.getElementsByClassName('pic-under-navbar');
        if (collection.length) {
            collection[0].classList.add('safari');
        }
    }
    if (model.newPrintPreview) {
        const collection = document.getElementsByClassName('pic-under-navbar');
        if (collection.length) {
            collection[0].classList.add('new-preview');
        }
    }

    //PageUtilities.init();
    Files.init();

    //PrintServer.init();
});

// TODO - Enum'id tuleks korrektsuse mõttes ümber kirjutada const ja Object.freeze peale.
// See tagaks, et enumeid ei saa pärast enam programmi koodis muuta.
// Näiteks: const DaysEnum = Object.freeze({"monday":1, "tuesday":2, "wednesday":3, ...})
var Enums = {
    ColorModeEnum: {
        UNDEFINED: 0,
        BW: 1,
        COLOR: 2
    },
    DuplexModeEnum: {
        UNDEFINED: 0,
        SINGLE: 1,
        LONG: 2,
        SHORT: 3
    },
    PrintSizeEnum: {
        UNDEFINED: '',
        A4: 'A4',
        A3: 'A3'
    },
    ScalingModeEnum: {
        NOTAVAILABLE: -1,
        UNDEFINED: 0,
        ORIGINAL: 1,
        FITTOPAGE: 2,
        FITTOMARGINS: 3,
        FILLPAGE: 4
    },
    UploadStatusEnum: {
        NEW: 0,
        UPLOADING: 1,
        CANCELLED: 2,
        COMPLETE: 3,
        ERROR: 4
    },
    MessageTypeEnum: {
        UNDEFINED: 0,
        INFO: 1,
        WARNING: 2,
        ERROR: 3
    }
};
var titles = [model.localization.Pages_Print_SectionTitle_UploadFiles, model.localization.Pages_Print_SectionTitle_CreateJob, model.localization.Pages_Print_SectionTitle_ChoosePrintPoint];

var Partners = (function () {
    function calculateJobPrices() {
        var pageCounts = app1.files.map(function (f) { return parseInt(f.pages, 10); });
        var activeJobPrice;
        var defaultJobPrice;

        if (pageCounts.length === 0) {
            return;
        }
        app1.partners.forEach(function (partner) {
            activeJobPrice = 0;
            defaultJobPrice = 0;
            app1.files.forEach(function (file) {
                var filePrice = file.calculatePrice(partner.priceProfiles)
                activeJobPrice += filePrice.activePrice;
                defaultJobPrice += filePrice.defaultPrice;
            });
            partner.jobPrice = {
                amount: activeJobPrice,
                visible: activeJobPrice === 0 || activeJobPrice === null || isNaN(activeJobPrice) ? '-' : buildVisiblePrice(activeJobPrice, model.currencyInfo, 2, 4),
                defaultAmount: defaultJobPrice,
                defaultVisible: defaultJobPrice === 0 || defaultJobPrice === null || isNaN(defaultJobPrice) ? '-' : buildVisiblePrice(defaultJobPrice, model.currencyInfo, 2, 4)
            };
        });
    }

    function getPartners() {
        var partners = JSON.parse(model.printPartners);

        partners.forEach(partner => partner.jobPrice = {});
        return partners;
    }

    return {
        calculateJobPrices: calculateJobPrices,
        getPartners: getPartners
    };
}());

Vue.prototype.$enums = Enums;

Vue.component('available-devices-list', {
    template: '#available-devices-list-template',
    props: ['devices', 'jobSettings'],
    computed: {
        header: function () {
            return model.localization.pages_Print_TargetDevicesSingle.pluralize(this.devices.length, model.localization.pages_Print_TargetDevicesMany);
        }
    }
});

Vue.component('price-modal', {
    template: '#price-modal-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        }
    },
    props: ['data']
});

Vue.component('file-upload-queue-item', {
    template: '#file-upload-queue-item-template',
    props: ['file', 'index'],
    computed: {
        getFullDescription: function () {
            return this.file.getFullDescription();
        },
        cancelButtonLabel: function () {
            return this.file.cancelButtonLabel();
        }
    }
});

Vue.component('file-settings-item', {
    template: '#file-settings-item-template',
    props: ['file', 'index'],
    data: function () {
        return {
            xAxis: '-57',
        }
    },
    computed: {
        copiesText: function () {
            return '{0} {1} x {2}\xa0{3}'.format(this.file.pages, model.localization.pages_Print_PageAbbr.pluralize(this.file.pages, model.localization.pages_Print_PagesAbbr), this.file.settings.copyCount, model.localization.pages_Print_CopyAbbr.pluralize(this.file.settings.copyCount, model.localization.pages_Print_CopiesAbbr));
        },
        cancelButtonLabel: function () {
            return this.file.cancelButtonLabel();
        }
    },
    watch: {
        'file.settings': {
            handler: function () {
                this.file.updatePriceRange();
                Partners.calculateJobPrices();
            },
            deep: true
        }
    },
    mounted: function () {
        if (!app1.isMediaXs) {
            tippy('.left .jobPrice span:nth-of-type(' + (this.index + 1) + ')', {
                followCursor: 'horizontal',
                plugins: [followCursor],
                maxWidth: 'none'
            });
        } else {
            var hammertime = new Hammer(this.$el);
            hammertime.get('pan').set({ threshold: 25, direction: Hammer.DIRECTION_HORIZONTAL });
            hammertime.on('panstart', function (ev) {
                const collection = document.getElementsByClassName('toDelete');
                if (collection.length) {
                    collection[0].style.left = 0;
                    collection[0].classList.remove('toDelete');
                }
            });
            hammertime.on('panend', function (ev) {

                if (57 < (Math.abs(this.xAxis))) {
                    this.xAxis = -57;
                    this.$el.classList.add('toDelete');
                } else {
                    this.xAxis = 0;
                }

            }.bind(this));
            hammertime.on('pan', function (ev) {
                /*if (ev.pointerType == 'touch' && (Math.abs(ev.velocityY) > Math.abs(ev.velocityX))) { } else {*/
                if (ev.pointerType == 'touch' && (ev.center.x == 0 && ev.center.y == 0)) { } else {
                    if (ev.deltaX > 0) {
                        this.xAxis = 0
                    } else {
                        this.xAxis = ev.deltaX;
                        if (ev.deltaX < -56) {
                            this.$el.classList.add('toDelete');
                        } else {
                            this.$el.classList.remove('toDelete');
                        }
                    }
                }
            }.bind(this));

            this.$el.classList.add('animate-delete');

            setTimeout(function () {
                if (this.file.status != 4) {
                    this.xAxis = '0';
                } else {
                    this.xAxis = '-57';
                }
            }.bind(this), 100)
            setTimeout(function () {
                this.$el.classList.remove('animate-delete')
            }.bind(this), 1000)
        }
    }
});

Vue.component('file-settings-item-preview', {
    template: '#file-settings-item-preview-template',
    props: ['file'],
    computed: {

    },
    updated: function () {
        this.file.isPreviewLoading = true;
    },
});
Vue.component('busy-loader', {
    template: '#busy-loader-template',
    props: ['file'],
});
Vue.component('mobile-settings-toggles', {
    template: '#mobile-settings-toggles-template',
    data: function () {
        return {
            current: '',
        }
    },
    props: ['settings', 'media-type', 'current-file'],
    methods: {
        setColorMode: function (colorMode) {
            this.closeAllSettings();
            this.settings.colorMode = colorMode;
        },
        setDuplexMode: function (duplexMode) {
            this.closeAllSettings();
            this.settings.duplexMode = duplexMode;
        },
        setPrintSize: function (printSize) {
            this.closeAllSettings();
            this.settings.printSize = printSize;
        },
        setScalingMode: function (scalingMode) {
            this.closeAllSettings();
            this.settings.scalingMode = scalingMode;
        },
        updateCopyCount: function (action) {
            if (action === 'subtract') {
                this.settings.copyCount--;
            }
            else {
                this.settings.copyCount++;
            }
        },
        closeAllSettings: function () {
            document.querySelectorAll('.btn-wrap').forEach(function (elem) {
                elem.classList.remove('active');
            });
            document.getElementById('setting-values').style.top = 0;
        },
        openSetting: function (e, settingName) {
            if (settingName) {
                this.current = settingName;
            }

            Vue.nextTick(() => {
                document.getElementById('setting-values').style.top = -document.getElementById('setting-values').offsetHeight + 1 + 'px';
                var currentEl = e.target.closest('.btn-wrap');
                if (currentEl.classList.contains('active')) {
                    document.getElementById('setting-values').style.top = 0;
                    currentEl.classList.remove('active');
                } else {
                    document.querySelectorAll('.btn-wrap').forEach(function (elem) {
                        elem.classList.remove('active');
                    });
                    document.getElementById('setting-values').style.top = -document.getElementById('setting-values').offsetHeight + 1 + 'px';

                    currentEl.classList.add('active');
                }
            });
        },
        validateCopyCount: function (copyCount, onBlur) {
            var result = copyCount;
            if (copyCount === '' && onBlur === true) {
                result = 1;
            }
            if (parseInt(copyCount) < 1) {
                result = 1;
            }
            if (parseInt(copyCount) > 999) {
                result = 999;
            }
            return result;
        }
    },
    computed: {
        copyText: function () {
            return '{0}\xa0{1}'.format(this.settings.copyCount, model.localization.pages_Print_CopyAbbr.pluralize(this.settings.copyCount, model.localization.pages_Print_CopiesAbbr));
        },
        maxWidth: function () {
            if (this.mediaType == 'image/jpeg') {
                return '25vw';
            } else {
                if (this.currentFile.pages > 1) {
                    return '25vw';
                } else {
                    return '33.333vw';
                }
            }
        }
    },
    watch: {
        settings: {
            handler: function (val) {
                val.copyCount = this.validateCopyCount(val.copyCount);
            },
            deep: true
        }
    }
});
Vue.component('file-settings-toggles', {
    template: '#file-settings-toggles-template',
    props: ['settings', 'media-type', 'page-count'],
    methods: {
        setColorMode: function (colorMode) {
            this.settings.colorMode = colorMode;
        },
        setDuplexMode: function (duplexMode) {
            this.settings.duplexMode = duplexMode;
        },
        setPrintSize: function (printSize) {
            this.settings.printSize = printSize;
        },
        setScalingMode: function (scalingMode) {
            this.settings.scalingMode = scalingMode;
        },
        updateCopyCount: function (action) {
            if (action === 'subtract') {
                this.settings.copyCount--;
            }
            else {
                this.settings.copyCount++;
            }
        },
        validateCopyCount: function (copyCount, onBlur) {
            var result = copyCount;
            if (copyCount === '' && onBlur === true) {
                result = 1;
            }
            if (parseInt(copyCount) < 1) {
                result = 1;
            }
            if (parseInt(copyCount) > 999) {
                result = 999;
            }
            return result;
        }
    },
    watch: {
        settings: {
            handler: function (val) {
                val.copyCount = this.validateCopyCount(val.copyCount);
            },
            deep: true
        }
    }
});

Vue.component('file-settings-icon', {
    template: '#file-settings-icons-template',
    props: ['iconGroup', 'iconInGroup', 'tooltip'],
    mounted: function () {
        //$('[data-toggle="tooltip"]').tooltip();
    }
});
Vue.component('icon', {
    template: '#icons-template',
    props: ['name'],
});

var FileSettingVue = function () {
    var self = this;

    self.colorMode = Enums.ColorModeEnum.BW;
    self.duplexMode = Enums.DuplexModeEnum.SINGLE;
    self.printSize = Enums.PrintSizeEnum.A4;
    self.copyCount = 1;
    self.scalingMode = Enums.ScalingModeEnum.ORIGINAL;
    self.layout = '';

    self.colorModeDescription = function () {
        switch (self.colorMode) {
            case Enums.ColorModeEnum.BW:
                return model.localization.common_BW; //TODO
            case Enums.ColorModeEnum.COLOR:
                return model.localization.common_Color; //TODO
            default:
                return '';
        }
    };

    self.duplexModeDescription = function () {
        switch (self.duplexMode) {
            case Enums.DuplexModeEnum.SINGLE:
                return model.localization.common_SingleSided; //TODO
            case Enums.DuplexModeEnum.LONG:
                return model.localization.common_Duplex; //TODO
            default:
                return '';
        }
    };

    self.scalingModeDescription = function () {
        switch (self.scalingMode) {
            case Enums.ScalingModeEnum.ORIGINAL:
                return model.localization.pages_Print_Settings_ScalingOriginal
            case Enums.ScalingModeEnum.FITTOPAGE:
                return model.localization.pages_Print_Settings_ScalingFitToPage
            case Enums.ScalingModeEnum.FITTOMARGINS:
                return 'fit to margins'; //TODO
            default:
                return '';
        }
    };
};

var vueData = {
    activeStep: 1,
    bankInstructions: true,
    errorText: '',
    files: [],
    isMediaXs: false,
    newPrintPreview: model.newPrintPreview,
    isSubmitPrintJobInProgress: false,
    media: appMain.media,
    nonRegularBudgetText: '',
    partners: [],
    selectedPartnerId: '',
    selectedPartnerBudgetAndStatus: undefined,
    settings: new FileSettingVue(),
    showAllPartners: false,
    showPaymentOptions: false,
    helpInfoVisible: false,
    showPrintJobModal: false,
    printJobStatusMessage: '',
    search: '',
    showPriceDialog: false
};

var app1 = new Vue({
    el: '.pic-under-navbar',
    data: vueData,
    computed: {
        anySupportColor: function () {
            if (this.selectedPartner) {
                return this.selectedPartner.devices.some(device => device.hasColor);
            } else {
                return false;
            }
        },
        anySupportA3: function () {
            if (this.selectedPartner) {
                return this.selectedPartner.devices.some(device => device.hasA3);
            } else {
                return false;
            }
        },
        allSupportColor: function () {
            if (this.selectedPartner) {
                return this.selectedPartner.devices.filter(function (device) {
                    return !device.hasColor;
                }).length == 0;
            } else {
                return false;
            }
        },
        allSupportA3: function () {
            if (this.selectedPartner) {
                return this.selectedPartner.devices.filter(function (device) {
                    return !device.hasA3;
                }).length == 0;
            } else {
                return false;
            }
        },
        areAllFilesComplete: function () {
            var allComplete = this.files.length > 0 && this.files.length === this.files.filter(obj => obj.status === Enums.UploadStatusEnum.COMPLETE).length;
            return allComplete;
        },
        canPrint: function () {
            var result = false;
            this.errorText = '';
            this.nonRegularBudgetText = '';
            this.showPaymentOptions = false;
            if (model.oneStep) {
                result = true;
            } else {
                if (this.selectedPartner && this.selectedPartnerBudgetAndStatus) {

                    // Kui mingil põhjusel peaks kontoinfost valitud partneri info puuduma, siis kuvatakse puuduva kontoseisu teade.
                    if (this.selectedPartnerBudgetAndStatus === undefined) {
                        this.errorText = model.localization.pages_Print_ErrorInsufficientBalance;
                    }
                    else {
                        if (this.isAnyColor && !this.anySupportColor) {
                            //this.errorText = model.localization.pages_Print_ErrorNoColorPrinters;
                        }
                        else if (this.isAnyA3 && !this.anySupportA3) {
                            //this.errorText = model.localization.pages_Print_ErrorNoA3Printers;
                        }
                        else if (!this.selectedPartnerBudgetAndStatus.isPartnerOnline) {
                            this.errorText = model.localization.pages_Print_ErrorServerNotOnline;
                        }
                        else {
                            if (((this.jobPrice.amount > window.appMain.currentBudget.budget && !this.selectedPartnerBudgetAndStatus.isUnlimited) && (this.jobPrice.amount > this.selectedPartnerBudgetAndStatus.budget && !this.selectedPartnerBudgetAndStatus.isUnlimited))) {
                                this.errorText = model.localization.pages_Print_ErrorInsufficientBalance;
                                this.showPaymentOptions = true;
                            }
                            else {
                                result = true;
                            }

                            if (this.selectedPartnerBudgetAndStatus.isLocalOnly || this.selectedPartnerBudgetAndStatus.isUnlimited) {
                                this.nonRegularBudgetText = this.selectedPartnerBudgetAndStatus.isLocalOnly ? buildVisiblePrice(this.selectedPartnerBudgetAndStatus.budget, this.selectedPartnerBudgetAndStatus.currencyInfo, 2, 4) : model.localization.common_Unlimited;
                                this.showPaymentOptions = false;
                            }
                        }
                    }
                }
            }
            return result;
        },
        devicesSorted: function () {
            return this.selectedPartner.devices.sort((x, y) => ((!x.hasA3 && this.isAnyA3) || (!x.hasColor && this.isAnyColor)) - ((!y.hasA3 && this.isAnyA3) || (!y.hasColor && this.isAnyColor)));
        },
        filteredPartners: function () {
            if (model.oneStep) {
                return [];
            } else {
                return this.partners.filter(item => {

                    let isFound = false;

                    isFound = item.name.toLowerCase().includes(this.search.toLowerCase())
                    if (!isFound) {
                        item.devices.forEach(device => {
                            isFound = isFound || device.name.toLowerCase().includes(this.search.toLowerCase())
                        })
                    }

                    return isFound;
                })
            }
        },
        isAnyA3: function () {
            var isA3 = false;
            this.files.forEach(function (file) {
                if (file.settings.printSize === Enums.PrintSizeEnum.A3) {
                    isA3 = true;
                }
            });
            return isA3;
        },
        isAnyColor: function () {
            var isColor = false;
            this.files.forEach(function (file) {
                if (file.settings.colorMode === Enums.ColorModeEnum.COLOR) {
                    isColor = true;
                }
            });
            return isColor;
        },
        jobPages: function () {
            var result = 0;
            this.files.forEach(function (file) {
                result += file.pages * file.settings.copyCount;
            });
            return result;
        },
        jobPrice: function () {
            var result = null;
            if (this.selectedPartner) {
                //selectedPartnerPriceProfiles = this.selectedPartner.priceProfiles;

                //this.files.forEach(function (file) {
                //    result += file.calculatePrice(selectedPartnerPriceProfiles, file).activePrice;
                //});
                result = this.selectedPartner.jobPrice;
            }

            return {
                amount: result.amount,
                //visible: buildVisiblePrice(result, model.currencyInfo)
                visible: result.visible
            };
        },
        jobPriceRange: function () {
            var jobMinPrice = 0;
            this.files.forEach(function (file) {
                jobMinPrice += file.minPrice;
            });
            var jobMaxPrice = 0;
            this.files.forEach(function (file) {
                jobMaxPrice += file.maxPrice;
            });

            if (jobMinPrice === Number.MAX_VALUE || jobMaxPrice === Number.MIN_VALUE || this.files.length === 0 || isNaN(jobMinPrice) || isNaN(jobMaxPrice)) {
                return { value: model.localization.pages_Print_ErrorNotPossibleToPrint, hasPrice: false, isRange: false };
            }
            else if (jobMinPrice === jobMaxPrice) {
                return { value: buildVisiblePrice(jobMinPrice, model.currencyInfo, 2, 4), hasPrice: true, isRange: false };
            }
            else {
                return { value: buildVisiblePrice(jobMinPrice, model.currencyInfo, 2, 4) + ' – ' + buildVisiblePrice(jobMaxPrice, model.currencyInfo, 2, 4), hasPrice: true, isRange: true };
            }
        },
        allPrices: function () {
            const allPrices = this.files.flatMap(x => x.allPrices);
            const grouped = {};
            allPrices.forEach(({ id, location, price }) => {
                if (!grouped[id]) {
                    grouped[id] = { location, price: 0, formattedPrice: 0 };
                }
                grouped[id].price += price;
            });
            Object.values(grouped).forEach(item => {
                item.formattedPrice = buildVisiblePrice(item.price, model.currencyInfo, 2, 4);
            });
            return grouped;
        },
        selectedFiles: function () {
            return this.files.filter(function (file) {
                return file.isSelectedSettings;
            });
        },
        selectedPartner: function () {
            return this.partners.filter(function (partner) {
                return partner.id === app1.selectedPartnerId;
            })[0];
        },
    },
    watch: {
        files: function () {
            Partners.calculateJobPrices();
            if (app1.files.length === 1 && !app1.isMediaXs) {
                app1.selectAllFiles();
            }
        },
        jobPages: function () {
            // Pole ilmselt vaja, teises kohas uuendab juba ära vist
            //app1.files.forEach(function (file) {
            //    file.updatePriceRange();
            //})
        },
        settings: {
            handler: function (val) {
                this.updateSelectedFilesSettings();
                val.copyCount = this.validateCopyCount(val.copyCount);
            },
            deep: true
        },
        selectedFiles: function () {
            var self = this;

            if (self.selectedFiles.length > 0) {
                var colorModeValue = Enums.ColorModeEnum.UNDEFINED;
                var duplexModeValue = Enums.DuplexModeEnum.UNDEFINED;
                var printSizeValue = Enums.PrintSizeEnum.UNDEFINED;
                var scalingModeValue = Enums.ScalingModeEnum.UNDEFINED;
                var copyCountValue = '';
                self.selectedFiles.forEach(function (file, index) {
                    if (index === 0) {
                        colorModeValue = file.settings.colorMode;
                        duplexModeValue = file.settings.duplexMode;
                        printSizeValue = file.settings.printSize;
                        scalingModeValue = file.settings.scalingMode;
                        copyCountValue = file.settings.copyCount;
                    }
                    else {
                        if (colorModeValue !== file.settings.colorMode) {
                            colorModeValue = Enums.ColorModeEnum.UNDEFINED;
                        }
                        if (duplexModeValue !== file.settings.duplexMode) {
                            duplexModeValue = Enums.DuplexModeEnum.UNDEFINED;
                        }
                        if (printSizeValue !== file.settings.printSize) {
                            printSizeValue = Enums.PrintSizeEnum.UNDEFINED;
                        }
                        if (scalingModeValue !== file.settings.scalingMode) {
                            scalingModeValue = Enums.ScalingModeEnum.UNDEFINED;
                        }
                        if (copyCountValue !== file.settings.copyCount) {
                            copyCountValue = '';
                        }
                    }
                });
                self.settings.colorMode = colorModeValue;
                self.settings.duplexMode = duplexModeValue;
                self.settings.printSize = printSizeValue;
                self.settings.scalingMode = scalingModeValue;
                self.settings.copyCount = copyCountValue;
            }
        },
        selectedPartnerId: function () {
            this.selectedPartnerBudgetAndStatus = undefined;

            axios.get('/api/v1.0/me/budget/partners/' + this.selectedPartnerId)
                .then((response) => {
                    this.selectedPartnerBudgetAndStatus = response.data.filter(d => { return d.partnerId === this.selectedPartnerId })[0];
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    methods: {
        addFile: function (file) {
            this.files.push(file);
        },
        backToPartnerSelection: function () {
            this.selectedPartnerId = '';
        },
        deSelectAllFiles: function () {
            this.files.forEach(function (file) {
                file.isSelectedSettings = false;
                file.isPreviewVisible = false;
            });
        },
        jobPriceClick: function () {
            // 0.3-0.5ms per uploaded file
            this.files.forEach(function (file) {
                file.updatePriceRange(true);
            });
            this.showPriceDialog = true;
        },
        getReadableFileSizeString: function (fileSizeInBytes) {

            var i = -1;
            var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
            do {
                fileSizeInBytes = fileSizeInBytes / 1024;
                i++;
            } while (fileSizeInBytes > 1024);

            return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
        },
        handleFileUpload: function () {
            var uploadID = 'fileUpload';
            var maxUploadFileSizeInMB = 80;
            var genericUploadErrorText = model.localization.pages_Print_UnknownUploadError;
            var uploadCancelText = model.localization.pages_Print_FileUploadCancelled;
            var fileSizeErrorText = model.localization.pages_Print_FileTooLargeError.format(maxUploadFileSizeInMB);

            Array.from(this.$refs.filesToUpload.files).forEach((file, index) => {
                var startUpload = true;
                var tempID = Math.random().toString(36).substr(2, 5); // Generate temporary 5 character file ID

                var newElement = new UploadedFileVue(tempID, file.name, 0, Enums.UploadStatusEnum.NEW);
                newElement.size = this.getReadableFileSizeString(file.size);

                app1.addFile(newElement);

                file.tempID = tempID;
                if (!(/\.(pdf|jpe?g)$/i).test(file.name)) {
                    newElement.message = model.localization.pages_Print_WrongFileType;
                    newElement.status = Enums.UploadStatusEnum.ERROR;

                    startUpload = false;
                }
                if (file.size > maxUploadFileSizeInMB * 1024 * 1024) {
                    newElement.message = fileSizeErrorText;
                    newElement.status = Enums.UploadStatusEnum.ERROR;

                    startUpload = false;
                }
                if (startUpload === true) {
                    this.submitFile(file);

                } else {

                }
            });

            this.$refs.filesToUpload.value = null;
        },
        hideAllPreviews: function () {
            this.files.forEach(function (file) {
                file.isPreviewVisible = false;
            });
        },
        navigateToSection: function (section) {
            PageNavigation.router.navigate(section);
        },
        selectAllFiles: function () {
            this.files.forEach(function (file) {
                file.isSelectedSettings = true;
            });
        },
        selectPartner: function (event) {
            this.selectedPartnerId = event.currentTarget.dataset.id.toString();
        },
        sortFiles: function () {
            this.files = this.files.sort((x, y) => y.tooBig() - x.tooBig());
            //this.files = this.files.sort((x, y) => y.lowDPI() - x.lowDPI());
        },
        submitFile(file) {
            const CancelToken = axios.CancelToken;
            //for (var i = 0; i < this.$refs.filesToUpload.files.length; i++) {
            const source = CancelToken.source();
            let formData = new FormData();

            formData.append('file', file);
            axios.post('/api/v1.0/files/upload',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    cancelToken: source.token,
                    onUploadProgress: function (progressEvent) {
                        var uploadProgress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        var uploadedFile = vueData.files.filter(obj => obj.id == file.tempID)[0];
                        uploadedFile.cancelUpload = function () {
                            source.cancel();
                        };
                        uploadedFile.uploadProgress = uploadProgress;
                    }
                }
            ).then(function (response) {
                response.data.files.forEach(function (testfile, index) {
                    var uploadedFile = vueData.files.filter(obj => obj.id == file.tempID)[0];

                    if (response.data.files[index].error === 'WrongFileTypeException') {
                        uploadedFile.message = model.localization.pages_Print_WrongFileType;
                        uploadedFile.status = Enums.UploadStatusEnum.ERROR;
                    }
                    else if (response.data.files[index].error) {
                        // TODO #2194, kui internetiühendust pole siis kontrollida error net::ERR_INTRENET_DISCONNECTED
                        uploadedFile.message = model.localization.pages_Print_UnknownUploadError;
                        uploadedFile.status = Enums.UploadStatusEnum.ERROR;
                    }
                    else {
                        uploadedFile.id = response.data.files[index].id;
                        uploadedFile.pages = parseInt(response.data.files[index].pages, 10);
                        uploadedFile.mediaType = response.data.files[index].mediaType;
                        uploadedFile.fileProperties = response.data.files[index].fileProperties;
                        uploadedFile.status = Enums.UploadStatusEnum.COMPLETE;
                        if (model.newPrintPreview) {
                            if (app1.isMediaXs || uploadedFile.tooBig() || uploadedFile.lowDPI()) {
                                uploadedFile.toggleIsPreviewVisible();
                            }
                        }
                    }
                    uploadedFile.updatePriceRange();
                    Partners.calculateJobPrices();
                    app1.sortFiles();
                }.bind(this));

            }).catch(function (err) {
                console.log(err);
                console.log('FAILURE!!');
            });
            //}
            //        fail: function (e, data) {
            //            var errorText = genericUploadErrorText;
            //            var status;
            //            if (data.errorThrown === 'abort') {
            //                errorText = uploadCancelText;
            //                status = Enums.UploadStatusEnum.CANCELLED;
            //            }
            //            else {
            //                if (data.jqXHR.status === 404) {
            //                    errorText = fileSizeErrorText;
            //                    status = Enums.UploadStatusEnum.ERROR;
            //                }
            //            }
            //            $.each(data.files, function (index, file) {
            //                var uploadedFile = $.grep(vueData.files, function (obj) { return obj.id === file.tempID; })[0];
            //                uploadedFile.message = errorText;
            //                uploadedFile.status = status;
            //            });
            //        }
        },
        submitPrintJob: function () {
            if (this.isSubmitPrintJobInProgress || !this.canPrint || !this.areAllFilesComplete) {
                return;
            }
            this.isSubmitPrintJobInProgress = true;
            this.openPrintJobModal();

            var filesToPrint = [];
            this.files.forEach(function (file) {
                if (model.oneStep) {
                    var fileToPrint = {
                        id: file.id,
                        settings: file.settings
                    };
                } else {
                    var fileToPrint = {
                        id: file.id,
                        settings: file.settings,
                        partnerId: app1.selectedPartnerId
                    };
                }
                filesToPrint.push(fileToPrint);
            });
            
            // Use fetch with POST and ReadableStream
            const xsrfToken = document.getElementById('RequestVerificationToken').value;
            fetch('/api/v1.0/printjobs/stream', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': xsrfToken
                },
                body: JSON.stringify(filesToPrint)
            })
                .then(response => {
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();
                    const read = () => {
                        reader.read().then(({ done, value }) => {
                            if (done) return;
                            const chunk = decoder.decode(value, { stream: true });
                            chunk.split('\n').forEach(line => {
                                if (line.trim().length === 0) return;
                                try {
                                    const data = JSON.parse(line.replace(/^data:\s*/, ''));
                                    if (data.message) {
                                        this.printJobStatusMessage = data.message;
                                    }
                                    if (data.status === 'Completed') {
                                        //this.closePrintJobModal();
                                        window.location.replace(window.location.protocol + '//' + window.location.host + '/jobs');
                                    }
                                    if (data.status === 'Error') {
                                        this.printJobStatusMessage = data.message || 'An error occurred during print job submission.';
                                        this.isSubmitPrintJobInProgress = false;
                                    }
                                } catch (e) { }
                            });
                            read();
                        });
                    };
                    read();
                });
        },
        toggleColorMode: function (colorMode) {
            this.settings.colorMode = colorMode;
        },
        toggleDisplayElement: function (event) {
            this.bankInstructions = !this.bankInstructions;
        },
        toggleDuplexMode: function (duplexMode) {
            this.settings.duplexMode = duplexMode;
        },
        toggleHelpInfo: function () {
            this.helpInfoVisible = !this.helpInfoVisible;
        },
        togglePrintSize: function (printSize) {
            this.settings.printSize = printSize;
        },
        toggleScalingMode: function (scalingMode) {
            this.settings.scalingMode = scalingMode;
        },
        toggleShowAllPartners: function () {
            this.showAllPartners = true;
        },
        updateCopyCount: function (action) {
            if (action === 'subtract') {
                this.settings.copyCount--;
            }
            else {
                this.settings.copyCount++;
            }
        },
        updateSelectedFilesSettings: function () {
            var self = this;
            self.selectedFiles.forEach(function (file) {
                if (self.settings.colorMode !== Enums.ColorModeEnum.UNDEFINED) {
                    file.settings.colorMode = self.settings.colorMode;
                }
                if (self.settings.duplexMode !== Enums.DuplexModeEnum.UNDEFINED) {
                    file.settings.duplexMode = self.settings.duplexMode;
                }
                if (self.settings.scalingMode !== Enums.ScalingModeEnum.UNDEFINED) {
                    file.settings.scalingMode = self.settings.scalingMode;
                }
                if (self.settings.printSize !== Enums.PrintSizeEnum.UNDEFINED) {
                    file.settings.printSize = self.settings.printSize;
                }
                if (self.settings.copyCount !== '') {
                    file.settings.copyCount = self.settings.copyCount;
                }
            });
        },
        validateCopyCount: function (copyCount) {
            var result = copyCount;
            if (parseInt(copyCount) < 1) {
                result = 1;
            }
            if (parseInt(copyCount) > 999) {
                result = 999;
            }
            return result;
        },
        openPrintJobModal() {
            this.showPrintJobModal = true;
            this.printJobStatusMessage = '';
        },
        closePrintJobModal() {
            this.showPrintJobModal = false;
            this.printJobStatusMessage = '';
        },
    },
    mounted: function () {
        this.partners = Partners.getPartners();
        if (this.partners.filter(function (partner) { return partner.isFavorite === 'true'; }).length === 0 || this.partners.length <= 3) {
            this.showAllPartners = true;
        }

        // Initialize page width breakpoints
        var mqXs = window.matchMedia('(max-width: 767px)');
        this.isMediaXs = mqXs.matches;
        mqXs.addListener(function (e) {
            app1.isMediaXs = e.matches;
        });
        /* Drag-n-drop failid */
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
            document.body.addEventListener(evt, function (e) {
                e.preventDefault();
                e.stopPropagation();
            }.bind(this), false);
        }.bind(this));

        document.body.addEventListener('drop', function (e) {
            this.$refs.filesToUpload.files = e.dataTransfer.files;
            this.handleFileUpload();
        }.bind(this));
    }
});

var UploadedFileVue = function (id, name, pages, status) {
    var self = this;
    self.cancelUpload = {};
    self.currentPage = 1;
    self.id = id;
    self.isPreviewLoading = true;
    self.isPreviewVisible = app1.isMediaXs; // If mobile, preview always visible, if desktop then no
    self.isSelectedSettings = false;
    self.fileProperties;
    self.fullDescription = '';
    self.maxPrice = Number.MIN_VALUE;
    self.mediaType = 'application/octet-stream';
    self.message = '';
    self.minPrice = Number.MAX_VALUE;
    self.allPrices = [];
    self.name = name;
    self.pages = parseInt(pages, 10);
    self.settings = new FileSettingVue();
    self.settingsMessages = [];
    self.size = '';
    self.status = status;
    self.uploadProgress = 0;
    self.orientation = 'portrait';
    self.cancelButtonLabel = function () {
        if (self.status === Enums.UploadStatusEnum.NEW) {
            return model.localization.common_Cancel;
        }
        else if (self.status === Enums.UploadStatusEnum.COMPLETE) {
            return model.localization.pages_Print_DeleteFile;
        }
        else {
            return model.localization.pages_Print_RemoveFromList;
        }
    };
    //self.calculatePrice = function (printServerPrices) {
    self.calculatePrice = function (printServerPriceProfiles) {
        //if (isNaN(app1.jobPages)) {
        //    return;
        //}
        var activePagePrice;
        var defaultPagePrice;
        //var printServerPrices;
        var activePriceProfile = printServerPriceProfiles.filter(function (profile) {
            return profile.fromPageCount <= app1.jobPages;
        }).sort(function (a, b) {
            return b.fromPageCount - a.fromPageCount;
        })[0];
        var defaultPriceProfile = printServerPriceProfiles.filter(function (profile) {
            return profile.isDefault;
        })[0];

        //printServerPrices = defaultPriceProfile.prices;
        //printServerPriceProfiles.forEach(function (profile) {
        //    if (profile.isDefault) {
        //        printServerPrices = profile.prices;
        //    }
        //});

        if (self.settings.colorMode === Enums.ColorModeEnum.COLOR) {
            if (self.settings.printSize === Enums.PrintSizeEnum.A3) {
                if (typeof activePriceProfile.prices.A3C === 'undefined') {
                    activePagePrice = null;
                } else {
                    activePagePrice = activePriceProfile.prices.A3C;
                }
                if (typeof defaultPriceProfile.prices.A3C === 'undefined') {
                    defaultPagePrice = null;
                } else {
                    defaultPagePrice = defaultPriceProfile.prices.A3C;
                }
                //pagePrice = printServerPrices.A3C;
            }
            else {
                if (typeof activePriceProfile.prices.A4C === 'undefined') {
                    activePagePrice = null;
                } else {
                    activePagePrice = activePriceProfile.prices.A4C;
                }
                if (typeof defaultPriceProfile.prices.A4C === 'undefined') {
                    defaultPagePrice = null;
                } else {
                    defaultPagePrice = defaultPriceProfile.prices.A4C;
                }
                //if (typeof printServerPrices.A4C === 'undefined') {
                //    return null;
                //}
                //pagePrice = printServerPrices.A4C;
            }
        }
        else {
            if (self.settings.printSize === Enums.PrintSizeEnum.A3) {
                if (typeof activePriceProfile.prices.A3BW === 'undefined') {
                    activePagePrice = null;
                } else {
                    activePagePrice = activePriceProfile.prices.A3BW;
                }
                if (typeof defaultPriceProfile.prices.A3BW === 'undefined') {
                    defaultPagePrice = null;
                } else {
                    defaultPagePrice = defaultPriceProfile.prices.A3BW;
                }
                //if (typeof printServerPrices.A3BW === 'undefined') {
                //    return null;
                //}
                //pagePrice = printServerPrices.A3BW;
            }
            else {
                activePagePrice = activePriceProfile.prices.A4BW;
                defaultPagePrice = defaultPriceProfile.prices.A4BW;
                //pagePrice = printServerPrices.A4BW;
            }
        }

        var activeTotal = null;
        var defaultTotal = null;
        if (self.settings.duplexMode === Enums.DuplexModeEnum.SINGLE) {
            if (activePagePrice !== null) {
                activeTotal = activePagePrice * self.pages * self.settings.copyCount;
            }
            if (defaultPagePrice !== null) {
                defaultTotal = defaultPagePrice * self.pages * self.settings.copyCount;
            }
        }
        else {
            if (activePagePrice !== null) {
                activeTotal = (activePagePrice * self.pages) + (activePriceProfile.prices.DPX * (self.pages % 2 ? self.pages - 1 : self.pages));
                activeTotal = activeTotal * self.settings.copyCount;
            }
            if (defaultPagePrice !== null) {
                defaultTotal = (defaultPagePrice * self.pages) + (defaultPriceProfile.prices.DPX * (self.pages % 2 ? self.pages - 1 : self.pages));
                defaultTotal = defaultTotal * self.settings.copyCount;
            }
            //total = (pagePrice * self.pages) + (printServerPrices.DPX * (self.pages % 2 ? self.pages - 1 : self.pages));
            //total = total * self.settings.copyCount;
        }

        // exponential magic is needed to get rid of JavaScript floating-point arithmetic rounding errors
        //return Number(Math.round(total + 'e4') + 'e-4');
        return {
            activePrice: Number(Math.round(activeTotal + 'e4') + 'e-4'),
            defaultPrice: Number(Math.round(defaultTotal + 'e4') + 'e-4')
        };
    };

    self.getFullDescription = function () {
        if (self.status === Enums.UploadStatusEnum.COMPLETE) {
            if (self.mediaType === 'image/jpeg' && self.fileProperties !== undefined) {
                return '{0} ({1} x {2}mm @300dpi)'.format(self.name, (self.fileProperties.width / 300 * 25.4).toFixed(), (self.fileProperties.height / 300 * 25.4).toFixed());
            } else if (self.fileProperties !== null) {
                return '{0} ({1} {2})'.format(self.name, self.pages, model.localization.pages_Print_PageAbbr.pluralize(self.pages, model.localization.pages_Print_PagesAbbr));
            }
            else {
                return '{0} ({1} {2})'.format(self.name, self.pages, model.localization.pages_Print_PageAbbr.pluralize(self.pages, model.localization.pages_Print_PagesAbbr));
            }
        }
        else {
            return '{0} ({1})'.format(self.name, self.size);
        }
    };
    self.mmWidth = function () {
        var divide = 72;
        if (self.mediaType == 'image/jpeg') {
            divide = 300; // dpi
        }
        // PT / 72(inch) * 25.4(MM)
        let realWidth = (self.fileProperties.width / divide * 25.4).toFixed(); // cm
        return parseInt(realWidth);
    };
    self.mmHeight = function () {
        var divide = 72;
        if (self.mediaType == 'image/jpeg') {
            divide = 300; // dpi
        }
        // PT / 72(inch) * 25.4(MM)
        let realHeight = (self.fileProperties.height / divide * 25.4).toFixed();
        return parseInt(realHeight);
    };
    self.originalStyles = function () {
        var percentageHeight, percentageWidth, percentageLeft, percentageTop, coefficient, rotate = false;

        var realWidth = self.mmWidth();
        var realHeight = self.mmHeight();

        var jpegProps, realOrientation, testRotation;
        if (self.mediaType == 'image/jpeg') {
            jpegProps = self.fileProperties.jpegProperties;
            realOrientation = jpegProps.orientation
        }
        switch (realOrientation) {
            case 'RotateNoneFlipNone':
                testRotation = 'rotate(0deg)';
                break;
            case 'RotateNoneFlipY':
                // default paneb 270 -180px = 90 õige?
                testRotation = 'rotateY(180deg)';
                break;
            case 'Rotate270FlipX':
                testRotation = 'rotate(90deg)';
                realWidth = self.mmHeight();
                realHeight = self.mmWidth();
                break;
            case 'Rotate180FlipNone':
                // default paneb 270 -180px = 90 õige?
                testRotation = 'rotate(180deg)';
                break;
            case 'Rotate270FlipNone':
                testRotation = 'rotate(270deg)';
                realWidth = self.mmHeight();
                realHeight = self.mmWidth();
                break;
            case 'Unknown':
                testRotation = 'rotate(0deg)';
                break;
            case 'RotateNoneFlipX':
                testRotation = 'rotateX(180deg)';
                break;
            case 'Rotate270FlipY':
                testRotation = 'rotateY(-90deg)';
                realWidth = self.mmHeight();
                realHeight = self.mmWidth();
                break;
            case 'Rotate90FlipNone':
                testRotation = 'rotate(90deg)';
                realWidth = self.mmHeight();
                realHeight = self.mmWidth();
                break;
        }
        var ARatio = 297 / 210;

        var originalRatio = self.mmHeight() / self.mmWidth();

        if (self.mediaType == 'image/jpeg') {
            if (realWidth > realHeight) {
                originalRatio = realWidth / realHeight;
            } else {
                originalRatio = realHeight / realWidth;
            }
        }
        if (originalRatio < 1) {
            originalRatio = self.mmWidth() / self.mmHeight();
            percentageHeight = realHeight / 297;
            percentageWidth = realWidth / 420;
        } else {
            percentageHeight = realHeight / 420;
            percentageWidth = realWidth / 297;
        }

        if (self.mediaType != 'image/jpeg') {
            if (percentageWidth >= 1 || percentageHeight >= 1) {
                if (originalRatio < 1) {
                    percentageHeight = realHeight / self.mmHeight();
                    percentageWidth = realWidth / self.mmWidth();
                } else {
                    percentageHeight = realHeight / self.mmHeight();
                    percentageWidth = realWidth / self.mmWidth();
                }
            }
            
        }
        percentageTop = (1 - percentageHeight) / 2; // -0.2 / 2 * 100
        percentageLeft = (1 - percentageWidth) / 2;  // -0.14 = 0.07

        return {
            height: (percentageHeight * 100) + '%',
            width: (percentageWidth * 100) + '%',
            left: (percentageLeft * 100) + '%',
            top: (percentageTop * 100) + '%',
            //transform: 'rotate(270deg)'
            //transform: testRotation
            //transform: rotate ? 'rotate(270deg)' : 'none'
        }
        //width: 339px; height: 508px; top: -90px; left: -21.3px;

    }
    self.previewStyles = function () {
        var percentageHeight = 1, percentageWidth = 1, percentageLeft;

        if (self.settings.printSize === Enums.PrintSizeEnum.A4) {
            if ((self.mmHeight() > 297 || self.mmWidth() > 210) && self.settings.scalingMode === Enums.ScalingModeEnum.ORIGINAL) { // && (self.settings.scalingMode === 1 && self.mediaType == 'image/jpeg')
                percentageHeight = 297 / 420;
                percentageWidth = 210 / 297;
            } else {
                percentageHeight = 1;
                percentageWidth = 1;
            }
        }
        // Vaja aru saada, kui o nsobita lehele, et kas siis muudab orientationit. Eeldaks, et kui height väiksem kui width, siis pöörab ära?

        if (percentageWidth < 1) {
            percentageLeft = (1 - percentageWidth) / 2;
        } else {
            percentageLeft = 0;
        }
        return {
            height: (percentageHeight * 100) + '%',
            width: (percentageWidth * 100) + '%',
            left: (percentageLeft * 100) + '%'
        }
    },
        self.lowDPI = function () {
            if (self.fileProperties != null && self.settings.scalingMode == 2) {
                var divide = 72;
                if (self.mediaType === 'image/jpeg') {
                    divide = 300; // dpi
                }
                // PT / 72(inch) * 25.4(MM)
                let realWidth = (self.fileProperties.width / divide * 25.4).toFixed(); // cm
                let realHeight = (self.fileProperties.height / divide * 25.4).toFixed();
                if (self.settings.printSize === 'A4') {
                    if (realHeight >= realWidth) {
                        // multiply by two and if still smaller DPI is less than 150
                        return (realWidth * 2 < 210 || realHeight * 2 < 297);
                    } else {
                        return (realWidth * 2 < 297 || realHeight * 2 < 210)
                    }
                } else if (self.settings.printSize === 'A3') {
                    if (realHeight >= realWidth) {
                        return (realWidth * 2 < 297 || realHeight * 2 < 420)
                    } else {
                        return (realWidth * 2 < 420 || realHeight * 2 < 297)
                    }
                }
            } else {
                return false;
            }
        },
        self.tooSmall = function () {
            if (self.fileProperties !== null) {
                if (self.settings.scalingMode === 1) {
                    // scalingmode 1:1
                } else {
                    // scalingMode fit to page scalingmode = 2

                }
            } else {
                return false;
            }
        }
    self.tooBig = function () {
        if ((self.mediaType === 'image/jpeg' || self.mediaType === 'application/pdf') && self.fileProperties !== null && self.settings.scalingMode === 1) {
            var divide = 72;
            if (self.mediaType === 'image/jpeg') {
                divide = 300;
            }
            // PT / 72(inch) * 25.4(MM)
            let realWidth = (self.fileProperties.width / divide * 25.4).toFixed();
            let realHeight = (self.fileProperties.height / divide * 25.4).toFixed();
            if (self.settings.printSize === 'A4') {
                if (realHeight >= realWidth) {
                    return (realWidth > 210 || realHeight > 297)
                } else {
                    return (realWidth > 297 || realHeight > 210)
                }
            } else if (self.settings.printSize === 'A3') {
                if (realHeight >= realWidth) {
                    return (realWidth > 297 || realHeight > 420)
                } else {
                    return (realWidth > 420 || realHeight > 297)
                }
            }
        } else {
            return false;
        }
    }
    self.isComplete = function () {
        return self.status === Enums.UploadStatusEnum.COMPLETE;
    };

    self.isError = function () {
        if (self.status === Enums.UploadStatusEnum.ERROR || self.status === Enums.UploadStatusEnum.CANCELLED) {
            return true;
        }
        else {
            return false;
        }
    };

    self.priceRange = function () {
        if (self.minPrice === Number.MAX_VALUE || isNaN(self.minPrice)) {
            return { value: model.localization.pages_Print_ErrorNotPossibleToPrint, hasPrice: false, isRange: false };
        }
        else if (self.minPrice === self.maxPrice) {
            return { value: buildVisiblePrice(self.minPrice, model.currencyInfo, 2, 4), hasPrice: true, isRange: false };
        }
        else {
            return { value: buildVisiblePrice(self.minPrice, model.currencyInfo, 2, 4) + ' – ' + buildVisiblePrice(self.maxPrice, model.currencyInfo, 2, 4), hasPrice: true, isRange: true };
        }
    };
    self.fileLoaded = function () {
        var previewImageElement = document.getElementById('previewImageElement');
        if (previewImageElement && previewImageElement.width != 0 && previewImageElement.height != 0) {
            self.orientation = previewImageElement.naturalWidth > previewImageElement.naturalHeight ? 'landscape' : 'portrait';
            // self.orientation = (self.mmWidth() < self.mmHeight() || self.mediaType == 'image/jpeg') ? 'portrait' : 'landscape';
        }
        Vue.nextTick(() => {
            self.isPreviewLoading = false;
        });
    };
    self.previewUrl = function (getOriginalImage = false) {
        if (self.status !== Enums.UploadStatusEnum.COMPLETE) {
            return;
        }
        if (getOriginalImage && self.mediaType == 'image/jpeg') {
            return '/files/' + self.id;
        } else if (getOriginalImage) {
            return '/api/v1.0/files/' + self.id + '/pagePreview/' + self.currentPage + '/2/true';
        }
        var isA3 = false;
        if (self.settings.printSize === Enums.PrintSizeEnum.A3) {
            isA3 = true;
        }

        return '/api/v1.0/files/' + self.id + '/pagePreview/' + self.currentPage + '/' + self.settings.scalingMode + '/' + isA3;
    };
    self.createBackgroundString = function () {
        var backgroundA3 = '/api/v1.0/files/' + self.id + '/pagePreview/' + self.currentPage + '/' + self.settings.scalingMode + '/true';
        //var backgroundA3 = 'https://i.postimg.cc/VLGZjsbv/4000x6000.jpg';
        return 'repeating-linear-gradient(-45deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0.3) 10px, rgba(0, 0, 0, 0.3) 20px), url(' + backgroundA3 + ')';
    }
    self.remove = function (parent, index) {
        if (self.status === Enums.UploadStatusEnum.NEW) {
            self.cancelUpload();
            self.message = model.localization.pages_Print_FileUploadCancelled;
            self.status = Enums.UploadStatusEnum.CANCELLED;
        }
        else if (self.status === Enums.UploadStatusEnum.COMPLETE) {
            axios
                .delete('/api/v1.0/files/' + self.id)
                .then(function (response) {
                    if (response.status == 204) {
                        parent.files.splice(index, 1);
                    }
                })
                .catch(function (error) {
                    console.log(JSON.stringify(error, null, 2));
                });
        }
        else {
            parent.files.splice(index, 1);
        }
    };

    self.toggleIsPreviewVisible = function () {
        if (self.isSelectedSettings == false) {
            self.toggleSelectedSettings();
        }
        if (app1.isMediaXs && model.newPrintPreview) {
            self.isPreviewVisible = true;
        } else {
            self.isPreviewVisible = !self.isPreviewVisible;
        }
        self.isPreviewLoading = true;
    };

    self.toggleSelectedSettings = function () {
        if (self.isSelectedSettings === false) {
            app1.deSelectAllFiles();
            if (self.isPreviewVisible === false) {
                app1.hideAllPreviews();
            }
        }
        self.isSelectedSettings = !self.isSelectedSettings;
        // media xs
        //model.newPrintPreview
        if (app1.isMediaXs && model.newPrintPreview) {
            self.isPreviewVisible = true;
        }

        //if (self.tooBig() || self.lowDPI()) {
        //    self.isPreviewVisible = true;
        //} else {
        //    self.isPreviewVisible = false;
        //}

    };

    self.updateCurrentPage = function (action) {
        if (action === 'previous') {
            if (self.currentPage > 1) {
                self.currentPage--;
            }
        }
        else {
            if (self.currentPage < self.pages) {
                self.currentPage++;
            }
        }
    };

    self.updatePriceRange = function (updateAllPrintPointPrices) {
        var minPrice = Number.MAX_VALUE, maxPrice = Number.MIN_VALUE, price;
        if (updateAllPrintPointPrices) {
            self.allPrices = [];
        }

        for (var i in app1.partners) {
            price = self.calculatePrice(app1.partners[i].priceProfiles).activePrice;

            if (price !== null && !isNaN(price)) {
                if (updateAllPrintPointPrices) {
                    self.allPrices.push({ 'id': app1.partners[i].id, 'location': app1.partners[i].name, 'price': price, 'formattedPrice': buildVisiblePrice(price, model.currencyInfo, 2, 4) });
                }
                minPrice = Math.min(price, minPrice);
                maxPrice = Math.max(price, maxPrice);
            }
        }
        self.minPrice = minPrice;
        self.maxPrice = maxPrice;
    };
};
var PageNavigation;
if (!model.oneStep) {
    var PageNavigation = (function () {
        var router = {
            routes: [],
            mode: null,
            root: '/',
            init: function (options) {
                this.mode = options && options.mode && options.mode === 'history' && window.history && 'pushState' in window.history ? 'history' : 'hash';
                if (this.mode === 'history') {
                    window.onpopstate = function (event) {
                        console.log('location: ' + document.location + ', state: ' + JSON.stringify(event.state));
                    };
                }
                else {
                    var self = this;
                    window.onhashchange = function () {
                        self.findRoute(location.hash);
                    };
                    if (location.hash !== '') {
                        self.findRoute(location.hash);
                    }
                }
                return this;
            },
            addRoute: function (routeExpression, handler) {
                this.routes.push({ routeExpression: routeExpression, handler: handler });
                return this;
            },
            findRoute: function (path) {
                path = this.cleanPath(path);
                for (var i = 0; i < this.routes.length; i++) {
                    var match = path.match(this.routes[i].routeExpression);
                    if (match) {
                        this.routes[i].handler.apply({}, match);
                        return this;
                    }
                }
                return this;
            },
            cleanPath: function (path) {
                return path.toString().replace(/\/$/, '').replace(/^#?\/?/, '');
            },
            navigate: function (path, withoutHistory, title) {
                withoutHistory = withoutHistory === undefined ? false : withoutHistory;
                path = path ? path : '';
                if (this.mode === 'history') {
                    //history.pushState(null, null, this.root + this.clearSlashes(path));
                    throw 'Not implemented';
                }
                else {
                    if (withoutHistory === true) {
                        history.replaceState(null, null, '#' + this.cleanPath(path));
                    } else {
                        window.location = '#' + this.cleanPath(path);
                    }
                }
                if (title !== undefined) {
                    document.title = title;
                }
                return this;
            }
        };

        function loadStep(stepNo) {
            var numberOfSteps = document.getElementsByClassName('section-header').length;
            app1.activeStep = stepNo;
            if (stepNo > numberOfSteps || isNaN(stepNo)) {
                //$.address.value('1');
                router.navigate('1');
                document.title = titles[0] + ' - Print in City';
                return;
            } else {
                document.title = titles[stepNo - 1] + ' - Print in City';
            }
            if (app1.areAllFilesComplete || stepNo == 1) {
                app1.deSelectAllFiles();

                if (vueData.files.length === 1) {
                    if (!app1.isMediaXs) {
                        app1.selectAllFiles();
                    }
                }
            }
        }

        function init() {
            router.addRoute(/1$/, function () {
                loadStep(1);
            });
            router.addRoute(/2$/, function () {
                if (vueData.files.length !== 0) {
                    loadStep(2);
                }
                else {
                    router.navigate('1', true);
                }
            });
            router.addRoute('', function () {
                loadStep(1);
                router.navigate('1', true);
            });
            router.init({ mode: 'hash' });
        }

        return {
            init: init,
            router: router
        };
    }());
}
var Files = (function (self = {}) {

    function buildPendingFiles() {
        var pendingFiles = JSON.parse(model.pendingFiles);
        //var pendingFiles = $.parseJSON($('#hidPendingFilesJson').val().replace(/&quot;/g, '"'));
        for (var i in pendingFiles) {

            var file = new UploadedFileVue(pendingFiles[i].id, pendingFiles[i].name, parseInt(pendingFiles[i].pages, 10), Enums.UploadStatusEnum.COMPLETE);
            file.mediaType = pendingFiles[i].mediaType;
            file.fileProperties = pendingFiles[i].fileProperties;
            app1.addFile(file);
            app1.sortFiles();
            file.updatePriceRange();
        }
    }
    function getReadableFileSizeString(fileSizeInBytes) {

        var i = -1;
        var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
        do {
            fileSizeInBytes = fileSizeInBytes / 1024;
            i++;
        } while (fileSizeInBytes > 1024);

        return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    }
    function init() {
        buildPendingFiles();
    }

    self.init = init;
    return self;

}(Files));

var PageUtilities = (function () {
    var $pageError;
    var pageErrorDefaultText = model.localization.pages_Print_UnknownError;
    var helpInfoToggleTexts = [model.localization.pages_Print_HideInstructions, model.localization.pages_Print_ShowInstructions];
    function toggleHelpInfo() {
        var $helpInfo = $('#helpInfo');
        $('#helpInfoToggle').text($helpInfo.is(':visible') ? helpInfoToggleTexts[1] : helpInfoToggleTexts[0]);
        if ($('#helpInfo').is(':visible')) {
            $helpInfo.animate({
                right: '-=' + $helpInfo.outerWidth() + 'px'
            }, 400, function () {
                $helpInfo.hide();
            });
        }
        else {
            $helpInfo.css('right', -$helpInfo.outerWidth());
            $helpInfo.show();
            $helpInfo.animate({
                right: '+=' + $helpInfo.outerWidth() + 'px'
            });
        }
    }

    function init() {
        $pageError = $('#pageError');
        $.ajaxSetup({ error: PageUtilities.AjaxErrorHandler });

        $('#helpInfoToggle').text($('#helpInfo').is(':visible') ? helpInfoToggleTexts[0] : helpInfoToggleTexts[1]);
        $('#helpInfoToggle').click(function () {
            toggleHelpInfo();
        });
        $('#helpInfoClose').click(function () {
            toggleHelpInfo();
        });

        initCustomEventHandlers();
    }

    function initCustomEventHandlers() {
        //$('body').on('printServerChanged', UserBudget.showCredits);
    }

    function ajaxErrorHandler() {
        showPageError(pageErrorDefaultText);
    }

    function showPageError(errorText) {
        $pageError.html(errorText).show();
    }

    function hidePageError() {
        $pageError.hide();
    }

    return {
        init: init,
        showPageError: showPageError,
        hidePageError: hidePageError,
        ajaxErrorHandler: ajaxErrorHandler
    };
}());